module.exports = __webpack_public_path__ + "img/out.ebb45819.svg";